export function ajaxTest() {
	var data = {
		action: 'md_action',
		security: md_object.nonce
	};

	jQuery.ajax({
		data: data,
		success: function (response) {
			jQuery('#response').html(response);
		},
		error: function (err) {
			console.log(err);
		}
	});
}

export default { ajaxTest };
